const forty = [
  {
    name: 'a2p',
    type: '40',
    size: '40px'
  },
  {
    name: 'p2p',
    type: '40',
    size: '40px'
  },
  {
    name: 'add',
    type: '40',
    size: '40px'
  },
  {
    name: 'add-bank',
    type: '40',
    size: '40px'
  },
  {
    name: 'add-contact',
    type: '40',
    size: '40px'
  },
  {
    name: 'add-country',
    type: '40',
    size: '40px'
  },
  {
    name: 'add-new',
    type: '40',
    size: '40px'
  },
  {
    name: 'address-proof',
    type: '40',
    size: '40px'
  },
  {
    name: 'apps',
    type: '40',
    size: '40px'
  },
  {
    name: 'arrow-left',
    type: '40',
    size: '40px'
  },
  {
    name: 'arrow-right',
    type: '40',
    size: '40px'
  },
  {
    name: 'bank-checkmark',
    type: '40',
    size: '40px'
  },
  {
    name: 'bank-savings-account-2',
    type: '40',
    size: '40px'
  },
  {
    name: 'bank-stores',
    type: '40',
    size: '40px'
  },
  {
    name: 'bill',
    type: '40',
    size: '40px'
  },
  {
    name: 'bulk-sheet-payment',
    type: '40',
    size: '40px'
  },
  {
    name: 'bulk-sheet-request',
    type: '40',
    size: '40px'
  },
  {
    name: 'buying',
    type: '40',
    size: '40px'
  },
  {
    name: 'calendar',
    type: '40',
    size: '40px'
  },
  {
    name: 'centralized-management',
    type: '40',
    size: '40px'
  },
  {
    name: 'cheque',
    type: '40',
    size: '40px'
  },
  {
    name: 'clear-fill',
    type: '40',
    size: '40px'
  },
  {
    name: 'close',
    type: '40',
    size: '40px'
  },
  {
    name: 'confirmation',
    type: '40',
    size: '40px'
  },
  {
    name: 'customer-support',
    type: '40',
    size: '40px'
  },
  {
    name: 'devices',
    type: '40',
    size: '40px'
  },
  {
    name: 'direction-left',
    type: '40',
    size: '40px'
  },
  {
    name: 'direction-right',
    type: '40',
    size: '40px'
  },
  {
    name: 'diverse-optimized-internet-traffic',
    type: '40',
    size: '40px'
  },
  {
    name: 'dongle',
    type: '40',
    size: '40px'
  },
  {
    name: 'download',
    type: '40',
    size: '40px'
  },
  {
    name: 'extended-global-reach',
    type: '40',
    size: '40px'
  },
  {
    name: 'hosted-backbone',
    type: '40',
    size: '40px'
  },
  {
    name: 'information',
    type: '40',
    size: '40px'
  },
  {
    name: 'internet',
    type: '40',
    size: '40px'
  },
  {
    name: 'landline',
    type: '40',
    size: '40px'
  },
  {
    name: 'line',
    type: '40',
    size: '40px'
  },
  {
    name: 'livechat',
    type: '40',
    size: '40px'
  },
  {
    name: 'location',
    type: '40',
    size: '40px'
  },
  {
    name: 'location-stroke',
    type: '40',
    size: '40px'
  },
  {
    name: 'login',
    type: '40',
    size: '40px'
  },
  {
    name: 'mail',
    type: '40',
    size: '40px'
  },
  {
    name: 'multiple-billing-models',
    type: '40',
    size: '40px'
  },
  {
    name: 'notifications',
    type: '40',
    size: '40px'
  },
  {
    name: 'one-stop-shop',
    type: '40',
    size: '40px'
  },
  {
    name: 'order-status',
    type: '40',
    size: '40px'
  },
  {
    name: 'organization',
    type: '40',
    size: '40px'
  },
  {
    name: 'page-next',
    type: '40',
    size: '40px'
  },
  {
    name: 'page-previous',
    type: '40',
    size: '40px'
  },
  {
    name: 'pay-as-you-go',
    type: '40',
    size: '40px'
  },
  {
    name: 'pay-phone',
    type: '40',
    size: '40px'
  },
  {
    name: 'payments-bank',
    type: '40',
    size: '40px'
  },
  {
    name: 'proactive-alerts',
    type: '40',
    size: '40px'
  },
  {
    name: 'proactive-customized-customer-service',
    type: '40',
    size: '40px'
  },
  {
    name: 'rates',
    type: '40',
    size: '40px'
  },
  {
    name: 'refresh',
    type: '40',
    size: '40px'
  },
  {
    name: 'search',
    type: '40',
    size: '40px'
  },
  {
    name: 'secure-reliable',
    type: '40',
    size: '40px'
  },
  {
    name: 'selling',
    type: '40',
    size: '40px'
  },
  {
    name: 'speed',
    type: '40',
    size: '40px'
  },
  {
    name: 'star',
    type: '40',
    size: '40px'
  },
  {
    name: 'star-fill',
    type: '40',
    size: '40px'
  },
  {
    name: 'static-ips',
    type: '40',
    size: '40px'
  },
  {
    name: 'strong-india-network',
    type: '40',
    size: '40px'
  },
  {
    name: 'subscribe',
    type: '40',
    size: '40px'
  },
  {
    name: 'subscriber-advantage',
    type: '40',
    size: '40px'
  },
  {
    name: 'talk',
    type: '40',
    size: '40px'
  },
  {
    name: 'text',
    type: '40',
    size: '40px'
  },
  {
    name: 'time',
    type: '40',
    size: '40px'
  },
  {
    name: 'toll-free-call',
    type: '40',
    size: '40px'
  },
  {
    name: 'upgrade',
    type: '40',
    size: '40px'
  },
  {
    name: 'upload',
    type: '40',
    size: '40px'
  },
  {
    name: 'user-edited',
    type: '40',
    size: '40px'
  },
  {
    name: 'user-removed-access',
    type: '40',
    size: '40px'
  },
  {
    name: 'user-removed-invitation',
    type: '40',
    size: '40px'
  },
  {
    name: 'user-roles',
    type: '40',
    size: '40px'
  },
  {
    name: 'utilization',
    type: '40',
    size: '40px'
  },
  {
    name: 'vip-numbers',
    type: '40',
    size: '40px'
  },
  {
    name: 'warning',
    type: '40',
    size: '40px'
  },
  {
    name: 'warning-fill',
    type: '40',
    size: '40px'
  }
];

export default forty;



// WEBPACK FOOTER //
// ./src/containers/foundations/Icons/constants/forty.js